import ready, {HTML} from 'Utils';
import initParallax from 'Components/parallax.js';
import initMobileNav from './components/mobileNav';
import initSlickCarousel from './components/slickCarousel';

jQuery(function() {
	initParallax();
	initMobileNav();
	initSlickCarousel();
});